<cmps-dialog class="cmps-cdk-p-0">
    <cmps-dialog-body>
        <div class="cmps-cdk-d-flex cmps-cdk-px-1 cmps-cdk-py-0dot75">
            <div
                class="cmps-cdk-d-flex cmps-cdk-font-bold cmps-cdk-font-size-16p cmps-cdk-flex-grow-1 cmps-cdk-align-items-center"
            >
                Saved Presets
            </div>
            <div>
                <button
                    type="button"
                    class="cmps-cdk-bg-color-transparent cmps-cdk-border-width-0p cmps-cdk-w-34px cmps-cdk-h-34px cmps-cdk-p-0 cmps-cdk-text-left cmps-cdk-align-items-center cmps-cdk-d-flex cmps-cdk-justify-content-center not:disabled:cmps-cdk-cursor-pointer focus:not:focus-visible:cmps-cdk-outline-none hover:cmps-cdk-color-blue-100"
                    (click)="_dialogRef.close()"
                >
                    <cmps-icon svgIcon="close"></cmps-icon>
                </button>
            </div>
        </div>
        <div
            class="cmps-cdk-border-b-width-1p cmps-cdk-border-b-solid cmps-cdk-border-b-color-grey-100"
        ></div>
        <div class="cmps-cdk-p-1">
            <input
                type="text"
                class="cmps-cdk-border-radius-4px cmps-cdk-border-solid cmps-cdk-border-width-1p cmps-cdk-px-0dot5 cmps-cdk-py-0dot25 cmps-cdk-w-100pct"
                cmpsUikSearchInput
                [placeholder]="'Search presets...'"
                [keyword]="_state.metricKeywords"
                (keywordChange)="_onKeywordChange($event)"
            />
        </div>
        <div
            class="cmps-cdk-border-b-width-1p cmps-cdk-border-b-solid cmps-cdk-border-b-color-grey-100"
        ></div>
        <div
            class="cmps-cdk-w-512px cmps-cdk-max-h-384px cmps-cdk-d-flex cmps-cdk-flex-column cmps-cdk-overflow-y-auto"
        >
            <div
                class="cmps-cdk-p-2 cmps-cdk-text-center"
                *ngIf="!(_state.presets?.length > 0)"
            >
                No saved presets yet
            </div>
            <ng-container
                *ngFor="let p of _state.filteredPresets; let l = last"
            >
                <button
                    class="cmps-cdk-bg-color-white cmps-cdk-border-width-0p cmps-cdk-min-h-40p cmps-cdk-py-0 cmps-cdk-px-1 cmps-cdk-text-left cmps-cdk-d-flex cmps-cdk-cg-0dot5 cmps-cdk-align-items-center not:disabled:cmps-cdk-cursor-pointer focus:not:focus-visible:cmps-cdk-outline-none hover:cmps-cdk-bg-color-grey-100"
                    (click)="p.open = !p.open"
                >
                    <div
                        class="cmps-cdk-w-34px cmps-cdk-h-34px cmps-cdk-align-items-center cmps-cdk-d-flex cmps-cdk-justify-content-center"
                    >
                        <cmps-icon
                            [svgIcon]="
                                p.open ? 'chevron-down' : 'chevron-right'
                            "
                        ></cmps-icon>
                    </div>
                    <div
                        class="cmps-cdk-cg-1 cmps-cdk-d-flex cmps-cdk-flex-grow-1"
                    >
                        <span class="cmps-cdk-line-clamp-2">{{
                            p.presetName
                        }}</span>
                        <div
                            class="cmps-cdk-border-radius-12px cmps-cdk-font-bold cmps-cdk-px-0dot5 cmps-cdk-text-uppercase cmps-cdk-white-space-nowrap {{
                                p.dataSourceLabelColour
                            }}"
                        >
                            {{ p.viewParamLabels?.dataSourceLabel }}
                        </div>
                    </div>
                    <div>
                        <button
                            type="button"
                            class="cmps-cdk-bg-color-transparent cmps-cdk-border-width-0p cmps-cdk-w-34px cmps-cdk-h-34px cmps-cdk-p-0 cmps-cdk-text-left cmps-cdk-align-items-center cmps-cdk-d-flex cmps-cdk-justify-content-center not:disabled:cmps-cdk-cursor-pointer focus:not:focus-visible:cmps-cdk-outline-none hover:cmps-cdk-color-blue-100"
                            (click)="$event.stopPropagation(); _onLoadClick(p)"
                            [cmpsTooltipTrigger]="'Load Preset'"
                        >
                            <cmps-icon svgIcon="download"></cmps-icon>
                        </button>
                    </div>
                </button>
                <div
                    class="cmps-cdk-border-b-width-1p cmps-cdk-border-b-solid cmps-cdk-border-b-color-grey-100"
                    *ngIf="!l"
                ></div>
                <ng-container *ngIf="p.open">
                    <div
                        class="cmps-cdk-d-flex cmps-cdk-flex-column cmps-cdk-p-1 cmps-cdk-rg-1"
                    >
                        <div>
                            <div class="cmps-cdk-d-flex">
                                <div
                                    class="cmps-cdk-flex-20 cmps-cdk-font-bold"
                                >
                                    Date
                                </div>
                                <div class="cmps-cdk-flex-80">
                                    <div
                                        *ngIf="
                                            p.viewParamLabels
                                                ?.periodTypeValueLabel != null
                                        "
                                    >
                                        {{ 'Period Type' }} -
                                        {{
                                            p.viewParamLabels
                                                ?.periodTypeValueLabel
                                        }}
                                    </div>
                                    <div
                                        *ngIf="
                                            p.viewParamLabels
                                                ?.dateRangeValueLabel != null
                                        "
                                    >
                                        {{ 'Range' }} -
                                        {{
                                            p.viewParamLabels
                                                ?.dateRangeValueLabel
                                        }}
                                    </div>
                                </div>
                            </div>
                            <div class="cmps-cdk-d-flex">
                                <div
                                    class="cmps-cdk-flex-20 cmps-cdk-font-bold"
                                >
                                    Report Type
                                </div>
                                <div class="cmps-cdk-flex-80">
                                    {{ p.viewParamLabels?.reportTypeLabel }} -
                                    {{
                                        p.viewParamLabels?.reportTypeValueLabel
                                    }}
                                </div>
                            </div>
                            <div class="cmps-cdk-d-flex">
                                <div
                                    class="cmps-cdk-flex-20 cmps-cdk-font-bold"
                                >
                                    Dimensions
                                </div>
                                <div class="cmps-cdk-flex-80">
                                    <div
                                        *ngIf="
                                            p.viewParamLabels
                                                ?.dataDimensionALabel != null
                                        "
                                    >
                                        {{
                                            p.viewParamLabels
                                                ?.dataDimensionALabel
                                        }}
                                        -
                                        {{
                                            p.viewParamLabels
                                                ?.dataDimensionAValueLabel
                                        }}
                                    </div>
                                    <div
                                        *ngIf="
                                            p.viewParamLabels
                                                ?.dataDimensionBLabel != null
                                        "
                                    >
                                        {{
                                            p.viewParamLabels
                                                ?.dataDimensionBLabel
                                        }}
                                        -
                                        {{
                                            p.viewParamLabels
                                                ?.dataDimensionBValueLabel
                                        }}
                                    </div>
                                </div>
                            </div>
                            <div class="cmps-cdk-d-flex">
                                <div
                                    class="cmps-cdk-flex-20 cmps-cdk-font-bold"
                                >
                                    Metrics
                                </div>
                                <div class="cmps-cdk-flex-80">
                                    {{ p.viewParamLabels?.metricValueLabel }}
                                </div>
                            </div>
                        </div>
                        <div
                            class="cmps-cdk-cg-0dot75 cmps-cdk-d-flex cmps-cdk-justify-content-flex-end"
                        >
                            <div>
                                <button
                                    type="button"
                                    class="cmps-cdk-align-items-center cmps-cdk-bg-color-white cmps-cdk-border-color-red-100 cmps-cdk-border-radius-4px cmps-cdk-border-solid cmps-cdk-border-width-1p cmps-cdk-color-red-100 not:disabled:cmps-cdk-cursor-pointer cmps-cdk-d-inline-flex cmps-cdk-font-bold cmps-cdk-justify-content-center cmps-cdk-min-h-34p cmps-cdk-px-1 disabled:cmps-cdk-opacity-0dot5"
                                    [disabled]="p.deleting"
                                    (click)="_onDeleteClick(p)"
                                >
                                    <span class="cmps-cdk-line-clamp-1"
                                        >Delete</span
                                    >
                                </button>
                            </div>
                            <div>
                                <button
                                    type="button"
                                    class="cmps-cdk-align-items-center cmps-cdk-bg-color-blue-100 cmps-cdk-border-radius-4px cmps-cdk-border-width-0p cmps-cdk-color-white not:disabled:cmps-cdk-cursor-pointer cmps-cdk-d-inline-flex cmps-cdk-font-bold cmps-cdk-justify-content-center cmps-cdk-min-h-34p cmps-cdk-px-1 disabled:cmps-cdk-opacity-0dot5"
                                    [disabled]="p.deleting"
                                    (click)="_onLoadClick(p)"
                                >
                                    <span class="cmps-cdk-line-clamp-1"
                                        >Load</span
                                    >
                                </button>
                            </div>
                        </div>
                    </div>
                    <div
                        class="cmps-cdk-border-b-width-1p cmps-cdk-border-b-solid cmps-cdk-border-b-color-grey-100"
                    ></div>
                </ng-container>
            </ng-container>
        </div>
        <ng-container *ngIf="_state.presets?.length > 0">
            <div
                class="cmps-cdk-border-b-width-1p cmps-cdk-border-b-solid cmps-cdk-border-b-color-grey-100"
            ></div>
            <div
                class="cmps-cdk-d-flex cmps-cdk-justify-content-flex-end cmps-cdk-p-1"
            >
                <span
                    >{{ _state.presets?.length ?? 0 }}
                    {{ _state.presets?.length > 1 ? 'presets' : 'preset' }}
                </span>
            </div>
        </ng-container>
    </cmps-dialog-body>
</cmps-dialog>
